// src/features/tasks/services/taskAttachments.js
import { apiClient } from '../../../services/api/client';

export const taskAttachmentsAPI = {
  // List task attachments
  listTaskAttachments: (taskId) => 
    apiClient.get(`/api/v1/task-management/tasks/${taskId}/attachments`),

  // Attach file to task
  attachFileToTask: (taskId, data) => 
    apiClient.post(`/api/v1/task-management/tasks/${taskId}/attachments`, data),

  // Update attachment metadata
  updateAttachment: (taskId, attachmentId, data) => 
    apiClient.patch(`/api/v1/task-management/tasks/${taskId}/attachments/${attachmentId}`, data),

  // Remove attachment from task
  detachFileFromTask: (taskId, attachmentId) => 
    apiClient.delete(`/api/v1/task-management/tasks/${taskId}/attachments/${attachmentId}`),
};